import axios from "axios";
import { CONST } from "../config/const";

export async function postHashValue(paymentFormData: {
  pay_method: string;
  merchant_id: string;
  service_id: string;
  cust_code: string;
  order_id: string;
  item_id: string;
  item_name: string;
  service_type: string;
  success_url: string;
  cancel_url: string;
  error_url: string;
  pagecon_url: string;
  request_date: string;
  sps_hashcode: string;
}) {
  try {
    const path = "hashValue";
    const bodys = {
      pay_method: paymentFormData.pay_method,
      merchant_id: paymentFormData.merchant_id,
      service_id: paymentFormData.service_id,
      cust_code: paymentFormData.cust_code,
      order_id: paymentFormData.order_id,
      item_id: paymentFormData.item_id,
      item_name: paymentFormData.item_name,
      service_type: paymentFormData.service_type,
      success_url: paymentFormData.success_url,
      cancel_url: paymentFormData.cancel_url,
      error_url: paymentFormData.error_url,
      pagecon_url: paymentFormData.pagecon_url,
      request_date: paymentFormData.request_date,
    };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    const hashValue: string = response.data.hash_value;
    return hashValue;
  } catch (error) {
    // logout();
    return "";
  }
}
